import React, { ComponentPropsWithoutRef } from 'react'

export const UnlinkIcon = (props: ComponentPropsWithoutRef<'svg'>) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clip-path="url(#clip0_262_47546)">
      <path
        d="M10.9901 7.14591L11.9934 6.14841H11.9817C12.5188 5.59193 12.813 4.84509 12.7999 4.07185C12.7868 3.29861 12.4674 2.56218 11.9117 2.02424C11.3675 1.49936 10.6408 1.20605 9.88466 1.20605C9.12852 1.20605 8.40186 1.49936 7.85758 2.02424L6.85425 3.02174"
        stroke="#6B7280"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.0158 6.85425L2.0183 7.85175C1.48126 8.40822 1.187 9.15507 1.20013 9.92831C1.21325 10.7016 1.53269 11.438 2.0883 11.9759C2.63258 12.5008 3.35924 12.7941 4.11538 12.7941C4.87152 12.7941 5.59818 12.5008 6.14246 11.9759L7.13996 10.9784"
        stroke="#6B7280"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.66675 1.16675V2.91675"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.16675 4.66675H2.91675"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.33325 11.0833V12.8333"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.0833 9.33325H12.8333"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_262_47546">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
